/*
* Project: LegalPlace assistant
* File: src/components/preview.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/


import React, { Component } from 'react';
import { connect } from 'react-redux';
import PreviewRow from './preview_row';
import { generateId1 } from './utils/misc';
import { togglePreview } from '../redux/actions/toggle_preview';
import { lpIdGetPure } from '../logic/global_getter';
import lpevents from '../tracking/lpevents';
import { _lp } from '../logic/wording';
import lpApp from '../app/lp_app';

let numberOfAll = 0;


// calculation of page numbers


class _Preview extends Component {
  constructor(props) {
    super(props);
    this.len = 0;
    this.updateNumbersTimer = null;
    this.state = {
      page_length: 0,
    };

    this.child_render_state = 0;
    this.last_view = props.views.length - 1;

    // console.log(props);
    this.goToPage = this.goToPage.bind(this);
    this.addChildRender = this.addChildRender.bind(this);
    window.preview_loop = 0;
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.variable) {
      return false;
    }
    if (nextProps.nah) return false;

    return true;
  }

  componentWillUpdate() {
    window.preview_loop += 1;

    // Reseting children render counter to 0
    this.child_render_state = 0;
  }


  componentDidUpdate() {
    // Updating auto numbers
    this.updateNumbers()
  }

  goToPage(id) {
    if (id <= this.state.page_length || id > 0) {
      this.setState({
      });
    }
  }

  addChildRender() {
    this.child_render_state += 1;

    // If all views were updated, we update auto numbers (this fixes the DEV-1416 bug)
    this.updateNumbers()
  }

  // eslint-disable-next-line
  updateNumbers() {
    const nbrSys = {};

    // this one must change
    const numbers = document.querySelectorAll('.aside .page [num-auto], .aside .page [num-auto-pre]');

    for (let i = 0; i < numbers.length; i += 1) {
      const v = numbers[i];
      if (v && v.attributes && v.attributes.getNamedItem('num-auto')) {
        nbrSys[v.attributes.getNamedItem('num-auto').value] = 0;
      } else {
        nbrSys[v.attributes.getNamedItem('num-auto-pre').value] = 0;
      }
    }

    Object.keys(numbers).forEach((idx) => {
      const element = numbers[idx];
      if (element && element.attributes && element.attributes.getNamedItem('num-auto')) {
        const counter = element.attributes.getNamedItem('num-auto').value;
        nbrSys[counter] += 1;
        element.innerHTML = nbrSys[counter];
      } else if (element && element.attributes) {
        const counter = element.attributes.getNamedItem('num-auto-pre').value;
        element.innerHTML = nbrSys[counter];
      }
    });
  }

  render() {
    if (lpApp.isPrerender === true) {
      return <div className="page">
        {this.props.views.map((idx, index) => {
          const last = (this.props.views.length - 1 === index) ? true : false

          return <PreviewRow
          key={generateId1(4)}
          idOut={idx[1]}
          out={idx[0]}
          lastView={last}
        />
        })}
      </div>;
    }

    // console.time("render");
    return (<div className="lp-doc-live-preview hidden-xs" onClick={this.props.togglePreview}>
      <h3>{_lp(this.props.title)}</h3>
      {this.props.wizard_loading ? <div className="loading-spin" /> : <div className="icn-glass" />}
      <div
        className="lp-doc-container lp-doc-sidebar"
        style={{ overflow: 'hidden' }}
        key={generateId1(3)}
      >
        {!this.props.wizard_loading && (<div className="lp-doc" ref="page_margin">
          <div className="page">
            {this.props.views.map((idx, index) => {
              const last = (this.props.views.length - 1 === index) ? true : false
              return <PreviewRow
                key={generateId1(4)}
                idOut={idx[1]}
                out={idx[0]}
                updateNumbers={this.updateNumbers}
                lastView={last}
              />
            })}
          </div>
        </div>)}
      </div>
    </div>);
    // console.timeEnd('render');
  }
}


const mapStateToProps = (state) => {
  // check the updatable conditions.
  numberOfAll = 0;
  let outputs = [];
  // The algorithm of grabbing the
  // get the section content
  // prepare options
  //    if(window.section_transition){
  //        return {
  //            in_transition: true
  //        }
  //    }

  if (state.contract === undefined || state.contract === null) {
    return {
      views: [],
    };
  }
  // if(!state.preview)return{
  //     is_modal: state.preview,
  //     preview: state.preview,
  //     views: []
  // }
  const la = lpApp.action_tracker.last_action;
  if ((la === 'EDIT_VARIABLE_VALUE_') || !lpApp.mutex.checkMutex('preview')) {
    // debugger;
    return {
      variable: true,
      views: [],
      context_variable: state.input_context.variable === '' ? 0 : lpIdGetPure(state.input_context.variable),
    };
  }
  switch (la) {
    case 'EDIT_OPTION_RADIO_':
    case 'CREATE_CONTRACT':
    case 'SET_SECTION_ID':
    case 'LOAD_OVC':
    case 'EDIT_OPTION_VALUE_':
    case 'SET_FULL_WIDTH':

      if (lpApp.mutex.checkMutex('preview')) {
        Object.keys(lpApp.indexes.real_sections.output_sections).forEach((idx) => {
          lpApp.ops.content.getOutput(
            lpApp.indexes.real_sections.getOutputSection(idx).options,
            outputs,
          );
        });
      }

      if (window.lml) window.lml += 1;
      else window.lml = 1;
      break;
    default:
      outputs = lpApp.indexes.content.getContent();
      numberOfAll = lpApp.indexes.content.getContentLength();
      break;
  }

  // TODO: work on
  lpApp.indexes.content.updateContent(outputs, numberOfAll);

  return {
    wizard_loading: state.loading_details.wizard,
    preview: state.preview,
    views: outputs,
    is_modal: state.preview,
    context_variable: state.input_context.variable === '' ? 0 : lpIdGetPure(state.input_context.variable),
    title: lpApp.references.customs.get('preview_title') === 'NONE' ? 'Aperçu de votre document' : lpApp.references.customs.get('preview_title'),
  };
};


const mapDispatchToProps = dispatch => ({
  togglePreview: () => {
    dispatch(togglePreview());
    lpevents.trackGTMGAEvent('Contrat aperçu', 'Clic', lpApp.getState().contract.name)
    lpevents.track('Opened preview popup');
  },
});

const Preview = connect(mapStateToProps, mapDispatchToProps)(_Preview);

export default Preview;



// WEBPACK FOOTER //
// ./src/components/preview.js